import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const requireComponent = require.context(
  '../components',
  false,
  /base(-[a-z]+)+\.(vue|js)$/
)

export default {
  install (Vue) {
    requireComponent.keys().forEach(fileName => {
      const componentConfig = requireComponent(fileName)

      const componentName = upperFirst(
        camelCase(
          fileName
            .split('/')
            .pop()
            .replace(/\.\w+$/, '')
        )
      )

      Vue.component(
        componentName,
        componentConfig.default || componentConfig
      )
    })
  }
}
